import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { CarouselItemStyle, Tutorial, TutoStepContent } from '@shared/models';
import { SafePipe, VariableReplacementPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant3',
  styleUrl: './variant3.component.scss',
  templateUrl: './variant3.component.html',
  imports: [SafePipe, VariableReplacementPipe],
})
export class Variant3Component extends BaseComponent {
  stepContent = input.required<
    Omit<TutoStepContent, 'indicatorImage' | 'picture'> & {
      picture?: TutoStepContent['picture'];
    }
  >();
  itemStyle = input.required<
    CarouselItemStyle & { background: string; flexDirection: string }
  >();

  tutorial: Tutorial = this.loyaltyChallengeConfig.components.tutorial;

  public maxSelectedChallenges: number = this.environment.maxSelectedChallenges;
}
